import {performGet} from "../network/RequestUtils";
import {getPreloadedMessagesForLocale} from './PreloadedMessages'
import {MessagesBase} from "./MessagesBase";

export interface DefaultMessagesConfig {
    url?: string;
    locale?: string;
}

// WARNING: There is a similar version of this in the Portal code
export class DefaultMessages extends MessagesBase {
    readonly url: string;

    constructor(config?: DefaultMessagesConfig) {
        super(config?.locale);
        this.url = config?.url || ""; // no default URL to force using preloaded map instead of fetching from server
    }

    private async loadMessagesFromServer(
        additionalFetchParameters?: Record<string, string>,
    ): Promise<object> {
        return await performGet<object>({
            url: this.url,
            cache: "no-cache",
            data: {
                locale: this.locale,
                ...additionalFetchParameters,
            },
        });
    }

    async load(additionalFetchParameters?: Record<string, string>): Promise<void> {
        // Avoid reloading it if it's already loaded
        if (this.map.get(this.locale)) {
            return;
        }

        // We do not have the data loaded for this locale, so try to load it from somewhere
        const localeMessages = getPreloadedMessagesForLocale(this.locale);
        if (localeMessages) {
            this.setMessageData(this.locale, localeMessages);
        } else if (this.url) {
            try {
                console.info("DefaultMessages: Loading messages from server...");
                const data = await this.loadMessagesFromServer(additionalFetchParameters);
                this.setMessageData(this.locale, data);
                console.info("DefaultMessages: loaded.");
            } catch (error) {
                console.debug("DefaultMessages: Error loading messages", error);
            }
        } else {
            console.warn(
                "DefaultMessages: Preloaded map has not been loaded for correct locale" +
                " before initializing Messages object, or URL not set for dynamic load"
            );
        }
    }
}
